import { render, staticRenderFns } from "./MarketFee.vue?vue&type=template&id=279cabde"
import script from "./MarketFee.vue?vue&type=script&lang=js"
export * from "./MarketFee.vue?vue&type=script&lang=js"
import style0 from "./MarketFee.vue?vue&type=style&index=0&id=279cabde&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/MarketFee.vue
// module id = null
// module chunks = 